var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.pageDesign === "login"
      ? _c(
          "div",
          {
            staticClass: "ui--form-login login-info",
            staticStyle: { width: "285px" }
          },
          [
            _c(
              "header",
              { staticClass: "mb-4" },
              [
                _c("img", {
                  staticClass: "mb-3 ui--brand-simbol",
                  attrs: {
                    src: _vm.$CONTEXT + "/static/image/main/simbol.png",
                    alt: "System Simbol"
                  }
                }),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "brand-text cursor-pointer",
                    attrs: { to: { name: "mainIndexPage" }, tag: "span" }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "mb-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "message" }, [
              _c("h5", [_vm._v(_vm._s(_vm.message))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("sdl.common.label.reloginmsg")))])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-primary",
                on: { click: _vm.goLogin }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("sdl.common.label.loginshortcut")) + "\n    "
                )
              ]
            )
          ]
        )
      : _c("div", { staticClass: "sdl-center wd-1" }, [
          _c("div", { staticClass: "msg-box" }, [
            _c(
              "div",
              {
                staticClass: "msg-icon",
                class: {
                  "text-center":
                    _vm.pageDesign === "common" || _vm.pageDesign === "inactive"
                }
              },
              [_c("em", { staticClass: "icon-info text-warning icon-size-2" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "msg-text" },
              [
                _vm.pageDesign === "inactive"
                  ? [
                      _c("h4", { staticClass: "mb-4" }, [
                        _vm._v(_vm._s(_vm.message))
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "list-unstyled" }, [
                        _c("li", [_vm._v(_vm._s(_vm.$t("sdl.commonError")))]),
                        _vm._v(" "),
                        _c("li", [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
                          ])
                        ])
                      ])
                    ]
                  : [
                      _c("h4", { staticClass: "mb-4" }, [
                        _vm._v(_vm._s(_vm.message))
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "list-unstyled" }, [
                        _c("li", [
                          _vm._v(_vm._s(_vm.$t("sdl.common.label.goMainPage")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "contact" }, [
                        _c("div", { staticClass: "d-block mb-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-lg btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.goMain }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("sdl.common.label.mainShortcut")
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-block" }, [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
                          ])
                        ])
                      ])
                    ]
              ],
              2
            )
          ])
        ]),
    _vm._v(" "),
    _vm.pageDesign === "login"
      ? _c("footer", { staticClass: "ui--footer-container" }, [
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("sdl.common.message.onlyAuthUserLegalSanctions")
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("© Samsung")])
        ])
      : _c("footer", { staticClass: "ui--footer-container" }, [
          _c("div", { staticClass: "ui--footer-in" }, [
            _c("span", [_vm._v("© Samsung")])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c0c86e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c0c86e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/EmptyPage.vue
// module id = null
// module chunks = 